import { useSetImmerAtom } from 'jotai-immer';
import {
    cpOrderInvoicesDataAtom,
    cpOrderInvoicesPageStateAtom,
    cpOrderInvoicesSearchFormAtom,
    cpOrderInvoicesTableFiltersAtom,
    cpOrderInvoicesTableStateAtom,
    cpOrderInvoicesTableStatsAtom,
    cpOrderInvoicesTableViewAtom,
    setAtomCpOrderInvoicesListTableViewState,
} from '../cp_order_invoices_list_atoms';
import { useEffect, useRef } from 'react';
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../../core/table/table_view_models';
import { cpOrderInvoicesListPageStateVM } from '../cp_order_invoices_list_view_models';
import { cpOrderInvoicesSearchStateVM } from '../search/cp_order_invoices_search_view_models';
import { CpOrderInvoicesDataItem } from '../cp_order_invoices_list_types';

export const useCpOrderInvoicesListDestroy = (): void => {
    const atomsDestroyed = useRef(false);
    // page
    const setPageState = useSetImmerAtom(cpOrderInvoicesPageStateAtom);

    // form
    const setSearchForm = useSetImmerAtom(cpOrderInvoicesSearchFormAtom);

    // table
    const setTableData = useSetImmerAtom(cpOrderInvoicesDataAtom);
    const setTableState = useSetImmerAtom(cpOrderInvoicesTableStateAtom);
    const setView = useSetImmerAtom(cpOrderInvoicesTableViewAtom);
    const setStats = useSetImmerAtom(cpOrderInvoicesTableStatsAtom);
    const setFilter = useSetImmerAtom(cpOrderInvoicesTableFiltersAtom);

    useEffect(() => {
        atomsDestroyed.current = false;

        return (): void => {
            // page
            setPageState(() => cpOrderInvoicesListPageStateVM());
            // form
            setSearchForm(() => cpOrderInvoicesSearchStateVM());
            // table
            setAtomCpOrderInvoicesListTableViewState(atomsDestroyed.current);
            setTableState(() => tableStateVM());
            setTableData(() => tableDataVM<CpOrderInvoicesDataItem>());
            setView(() => tableViewVM());
            setStats(() => tableStatsVM());
            setFilter(() => ({}));

            atomsDestroyed.current = true;
        };
    }, [setPageState, setSearchForm, setTableState, setTableData, setView, setStats, setFilter]);
};
